"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _reactList = _interopRequireDefault(require("@pcty/react-list"));
var _inputTextfield = require("@citrus/input-textfield");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    builderType = _ref.builderType,
    scenario = _ref.scenario,
    question = _ref.question,
    options = _ref.options,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    hint = _ref.hint,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.multipleText;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    typeId: questionTypeId
  };
  var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, builderType);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), (0, _PctyQuestionBuilder.renderKnockout)(id, knockout, knockoutText), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, editable ? /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }) : /*#__PURE__*/_react.default.createElement(_reactList.default, {
    className: "pcty-question-builder-single-question-list",
    automationId: "".concat(id, "-mt-list")
  }, getListItems(id, options)))));
};
var getListItems = function getListItems(id, options) {
  var retOptions = options.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
      automationId: "".concat(id, "-mt-item-").concat(index),
      key: "".concat(id, "-mt-item-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, item.value), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      id: "qb-".concat(item.id, "-mt-textfield-").concat(id.toString()),
      placeholder: "Enter text",
      onChange: function onChange(ixd, value) {
        return console.log("".concat(ixd, " text value => ").concat(value));
      }
    })));
  });
  return retOptions;
};
var _default = exports.default = Presentational;